<template>
<form class="content-form" v-on:submit.prevent="onSubmit" method="POST">
  <div class="field field-text">
    <input type="text" class="text" v-bind:placeholder="placeholder.name[lang]"
    v-bind:name="'name'"
    v-model="name"
    v-on:focus="inputOnFocus"
    v-validate.initial="{ rules: { required: true } }">
  </div>
  <transition name="error-fade">
    <span v-show="errors.has('name')" class="field-invalid">{{ errors.first('name') }}</span>
  </transition>

  <div class="field field-text">
    <input type="text" class="text" v-bind:placeholder="placeholder.business[lang]"
    v-bind:name="'business'"
    v-model="business"
    v-on:focus="inputOnFocus"
    v-validate.initial="{ rules: { required: true } }">
  </div>
  <transition name="error-fade">
    <span v-show="errors.has('business')" class="field-invalid">{{ errors.first('business') }}</span>
  </transition>

  <div class="field field-text">
    <input type="text" class="text" 
    v-bind:placeholder="placeholder.email[lang]"
    v-bind:name="'email'"
    v-model="email"
    v-on:focus="inputOnFocus"
    v-validate.initial="{ rules: { required: true, email: true } }">
  </div>
  <transition name="error-fade">
    <span v-show="errors.has('email')" class="field-invalid">{{ errors.first('email') }}</span>
  </transition>

  <div class="field field-submit mt2">
    <button class="btn btn-white">{{placeholder.submit[lang]}}</button>
  </div>
  <transition name="error-fade">
    <div class="field-result field-submitted mt2" v-if="isSubmitted">{{result.success[lang]}}</div>
  </transition>
  <transition name="error-fade">
    <div class="field-result field-errors mt2" v-if="errors.any()">{{result.error[lang]}}</div>
  </transition>
  
</form>
</template>
<script>
  import { Validator } from 'vee-validate';

  export default {
    name: 'Contact',
    data(){
      return {
        lang: localStorage.getItem('language') || 'en',
        isSubmitted: false,
        name: '',
        business: '',
        email: '',
        placeholder: {
          business: {
            en: 'Business',
            es: 'Empresa'
          },
          name: {
            en: 'Name',
            es: 'Nombre'
          },
          email: {
            en: 'Email',
            es: 'Email'
          },
          submit: {
            en: 'Send',
            es: 'Enviar'
          }
        },
        result: {
          success: {
            es: 'Tu mensaje ha sido enviado satisfactoriamente.',
            en: 'Thank you, we will get in touch with you soon!.'
          },
          error: {
            es: 'Hemos encontrado un error, por favor intenta nuevamente.',
            en: 'Whoops, we found some error, please try again. We hope you are a human.'
          }
        }
      }
    },
    methods: {
      inputOnFocus(event){
        document.querySelectorAll('#contact .field-text').forEach( (el) => {
          el.classList.remove('on-focus')
        })
        event.target.parentElement.classList.add('on-focus')
      },
      onSubmit(){
        // testing
        this.$validator.validateAll();
        if (this.errors.any()) return false
        
        this.axios.post( process.env.site.url + '/wp-json/nz-rest/v1/sendemail', {
          name: this.name,
          email: this.email,
          message: this.business
        }).then( (response) => {
          this.isSubmitted = true
          setTimeout(()=>{
            this.isSubmitted = false
          }, 3000 )
        })

      },
      reloadForm(){
        this.lang = localStorage.getItem('language') || 'en';
        this.$validator.setLocale(localStorage.getItem('language'));
        this.errors.clear();
      }
    },
    watch: {
      '$route': 'reloadForm'
    },
  }
</script>


// WEBPACK FOOTER //
// Contact.vue?60e26421